import { createFileRoute, Link } from '@tanstack/react-router'
import { Page } from '@/components/layout/page'

export const Route = createFileRoute('/mrgolisoda/')({
  component: MrGoliSodaHome,
})

const PAGES = [
  { label: 'GP Home', to: '/mrgolisoda/gp-home/' },
]

function MrGoliSodaHome() {
  return (
    <Page title="Mr GoliSoda">
      <div className="p-4 space-y-2">
        {PAGES.map((p) => (
          <Link
            key={p.to}
            to={p.to}
            className="flex items-center justify-between w-full rounded-xl border p-4 bg-white shadow-xs active:bg-gray-50"
            style={{ textDecoration: 'none', color: '#1A1A1A' }}
          >
            <span style={{ fontSize: 15, fontWeight: 600 }}>{p.label}</span>
            <span style={{ color: '#808080', fontSize: 18 }}>›</span>
          </Link>
        ))}
      </div>
    </Page>
  )
}
